var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOurMissionIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9815_7317)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.567533 8.6032C0.518001 8.48548 0.379689 8.42752 0.261251 8.47633C0.142939 8.52508 0.0861576 8.66464 0.134345 8.78261C0.182658 8.90086 0.323376 8.95777 0.440658 8.9092C0.55947 8.85998 0.614876 8.7217 0.567533 8.6032Z",
    fill: "#D9E7EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.91911 12.9077C2.86926 12.7898 2.73133 12.7322 2.6128 12.7811C2.49451 12.8299 2.4377 12.969 2.48592 13.0871C2.53417 13.2053 2.67473 13.2624 2.7922 13.214C2.91114 13.165 2.96636 13.026 2.91911 12.9077Z",
    fill: "#D9E7EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.72368 14.6678C8.67396 14.5503 8.53599 14.4917 8.4174 14.541C8.29915 14.5901 8.24221 14.7291 8.2908 14.8472C8.3393 14.9651 8.47927 15.0229 8.59677 14.9738C8.71399 14.9249 8.7734 14.7858 8.72368 14.6678Z",
    fill: "#D9E7EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.56119 1.80684C2.63194 1.69915 2.60222 1.55003 2.49328 1.48003C2.38865 1.41278 2.24384 1.44037 2.17328 1.54365C2.1014 1.64884 2.12765 1.79706 2.23312 1.86971C2.34025 1.94349 2.48834 1.91346 2.56119 1.80684Z",
    fill: "#D9E7EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.80189 3.87858C7.75236 3.76089 7.61399 3.70292 7.49561 3.7517C7.3773 3.80045 7.32055 3.94011 7.36871 4.05798C7.41711 4.17648 7.55755 4.23295 7.67502 4.18455C7.79399 4.13555 7.84918 3.99708 7.80189 3.87858Z",
    fill: "#D9E7EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1525 0.538583C10.0525 0.471146 9.91212 0.494677 9.83799 0.589146C9.75752 0.691739 9.77874 0.845114 9.88374 0.922271C9.98765 0.998614 10.1377 0.974677 10.213 0.869896C10.2898 0.762833 10.2601 0.612302 10.1525 0.538583Z",
    fill: "#D9E7EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0031 9.0165C14.9791 8.88835 14.846 8.80425 14.7201 8.83419C14.5952 8.86388 14.5144 8.99313 14.5459 9.11835C14.576 9.2381 14.6976 9.31644 14.8193 9.29213C14.9436 9.26735 15.0292 9.14116 15.0031 9.0165Z",
    fill: "#D9E7EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.32034 9.96295C8.44541 9.96295 8.55069 9.86033 8.55453 9.73564C8.55853 9.60564 8.45088 9.4937 8.32038 9.49414C8.19291 9.49458 8.086 9.60064 8.08594 9.72855C8.08591 9.8558 8.19294 9.96295 8.32034 9.96295Z",
    fill: "#D9E7EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7112 16.0716C13.6036 16.0007 13.4542 16.0306 13.3843 16.1395C13.3164 16.2453 13.3453 16.3916 13.4508 16.4616C13.557 16.532 13.7053 16.5032 13.7758 16.3966C13.847 16.2892 13.8169 16.1439 13.7112 16.0716Z",
    fill: "#D9E7EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.14712 1.97461L6.12812 5.78917L9.94269 6.77017L6.12812 7.75117L5.14712 11.5657L4.16613 7.75117L0.351562 6.77017L4.16613 5.78917L5.14712 1.97461Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9049 8.91016L11.6574 11.8361L14.5833 12.5885L11.6574 13.341L10.9049 16.2669L10.1525 13.341L7.22656 12.5885L10.1525 11.8361L10.9049 8.91016Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9782 0.734375L13.5731 3.04741L15.8861 3.64225L13.5731 4.23709L12.9782 6.55013L12.3833 4.23709L10.0703 3.64225L12.3833 3.04741L12.9782 0.734375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.14844 1.97461V11.5657L6.12944 7.75117L9.944 6.77017L6.12944 5.78917L5.14844 1.97461Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9766 0.734375V6.55013L13.5714 4.23709L15.8845 3.64225L13.5714 3.04741L12.9766 0.734375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9062 8.91016V16.2669L11.6587 13.341L14.5846 12.5885L11.6587 11.8361L10.9062 8.91016Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurMissionIcon);
export default __webpack_public_path__ + "static/media/our-mission-icon.2c5114d98498a80700d7bb5c7daac436.svg";
export { ForwardRef as ReactComponent };